import { Capacitor } from "@capacitor/core";
import loginWithGoogleForApp from "./loginWithGoogleForApp";
import loginWithGoogleForWeb from "./loginWithGoogleForWeb";

export default async function loginWithGoogle(setLoading) {
  const platform = Capacitor.getPlatform();

  try {
    if (platform === "android" || platform === "ios") {
      if (typeof setLoading == "function") setLoading(true);
      await loginWithGoogleForApp();
      if (typeof setLoading == "function") setLoading(false);
    } else if (platform === "web") {
      //we don't do loading part here because of api limitation and it will look bad
      await loginWithGoogleForWeb();
    } else {
      console.log("Unknown platform");
    }
  } catch (e) {
    window.popupAlert(JSON.stringify(e.message));
    window.popupAlert(JSON.stringify(e));
    if (typeof setLoading == "function") setLoading(false);
  }
}
